import React, { useState } from 'react'
import moment from 'moment'
import styled from 'styled-components'

import { downloadNlpLogs } from './utils'
import { alert } from '../../../../../../lib/bootbox'
import { useBotId } from '../../../../../../store/flow'
import { Button, ButtonType } from '../../../../../Styleguide/Button'
import { DateTimeRangePickerPopup } from '../../../../../modals/DateTimeRangePickerPopup'

export const NlpLogsDownloadButton: React.FC = () => {
  const botId = useBotId()
  const [isFileDownloading, setIsFileDownloading] = useState<boolean>(false)
  const [showDateTimeRangePicker, setShowDateTimeRangePicker] = useState<boolean>(false)

  return (
    <>
      {showDateTimeRangePicker && (
        <DateTimeRangePickerPopup
          onClose={() => setShowDateTimeRangePicker(false)}
          onConfirm={async (dateFrom, dateTo) => {
            if (!dateFrom) {
              return alert({
                title: '❌ Invalid date from',
                message:
                  'We are sorry, but without picked valid date from cannot download NLP logs.'
              })
            }

            const fromTimestamp = moment(Date.parse(dateFrom)).unix()
            const toTimestamp = moment(dateTo ? Date.parse(dateTo) : Date.now()).unix()
            if (fromTimestamp >= toTimestamp) {
              return alert({
                title: '❌ Invalid date from and date to',
                message:
                  'We are sorry, but without range where date from is sooner than date to cannot download NLP logs.'
              })
            }

            await downloadNlpLogs(botId, fromTimestamp, toTimestamp, setIsFileDownloading)
            setShowDateTimeRangePicker(false)
          }}
        />
      )}
      <StyledButton
        text="Download NLP logs"
        disabled={isFileDownloading}
        isLoading={isFileDownloading}
        buttonType={ButtonType.DEFAULT}
        onClickWhenDisabled={e => e.preventDefault()}
        onClick={event => {
          event.preventDefault()
          setShowDateTimeRangePicker(true)
        }}
      />
    </>
  )
}

const StyledButton = styled(Button)`
  margin: auto auto auto 0px;
`
